import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

export const Button = styled.div`
  text-align: ${props => props.theme.backButton.textAlign};
  font-size: ${props => props.theme.backButton.fontSize};
  color: ${props => props.theme.backButton.color};
  a {
    font-size: ${props => props.theme.backButton.fontSize};
    color: ${props => props.theme.backButton.color};
  }
`;

Button.defaultProps = {
  theme: {
    backButton: {
      fontSize: '16px',
      color: '#1A1A1A'
    }
  }
};

export default class BackButton extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    link: PropTypes.string,
    label: PropTypes.string
  };

  static defaultProps = {
    link: '/'
  };

  render () {
    return (
      <Button>
        <Link to={this.props.link} onClick={this.props.onClick}>{this.props.label || 'Terug'}</Link>
      </Button>
    );
  }
}
